import { useState } from 'react';
import { ManagedAccountsApi } from '@/api/clients/managed-accounts/managed-accounts.api';

export const useTestManagedAccountPositivePayConnection = (
  managedAccountId,
) => {
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);

  const testConnection = async () => {
    setTesting(true);
    setTestResult(null);

    try {
      const response = await ManagedAccountsApi.testPositivePayConnection(
        managedAccountId,
      );
      setTestResult(response.data.data);
    } finally {
      setTesting(false);
    }
  };

  const clearTestResult = () => setTestResult(null);

  return { testing, testResult, testConnection, clearTestResult };
};
